// Handlers for getting secret key for affiliation
export interface U3148GetSecretKeyHandlersHandlersParams<T = any> {
  doGetSecretKeyFn: () => Promise<any>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: any }) => void;
}

// Return type for getting secret key handlers
export interface U3148GetSecretKeyHandlersReturn {
  GetSecretKey: () => void;
}

// Handlers for getting secret key for affiliation
export function useU3148GetSecretKeyHandlers<T extends { id: string } = any>({ doGetSecretKeyFn, onSuccess, onError }: U3148GetSecretKeyHandlersHandlersParams<T>): U3148GetSecretKeyHandlersReturn {
  const GetSecretKey = async () => {
    try {
      const response = await doGetSecretKeyFn();
      const row: T = response.data.result as unknown as T;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { GetSecretKey };
}
